
{
  "defaults": {
    "select": "Select one",
    "multi-select": "Select more than one"
  }
}
